import React, { useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Container, Navbar } from "../../../components/ui";
import "./desktopNav.scss";
import "./mobileNav.scss";

import NavbarSearch from "./NavbarSearch";
import NavbarNav from "./NavbarNav/NavbarNav";
import NavbarToggle from "./NavbarToggle";
import DesktopNav from "./DesktopNav";
import publisherStore from "../../../flux/publisherStore";
import { getPublishers } from "../../../flux/publisherAction";

const MainNavbar = ({ layout, stickyTop = true }) => {
  const classes = classNames("main-navbar", stickyTop && "sticky-top");

  useEffect(() => {
    if (publisherStore.getPublishers().length === 0) getPublishers();
  }, []);

  return window.screen.width < 767 ? (
    <div className={classes}>
      <Container className="p-0">
        <Navbar type="light" className="align-items-stretch flex-md-nowrap p-0">
          <NavbarToggle />
          <NavbarSearch />
          <NavbarNav />
        </Navbar>
      </Container>
    </div>
  ) : (
    <div className={classes}>
      <Navbar type="light" className="align-items-stretch flex-md-nowrap p-0">
        <DesktopNav />
      </Navbar>
    </div>
  );
};

MainNavbar.propTypes = {
  layout: PropTypes.string,
  stickyTop: PropTypes.bool,
};

export default MainNavbar;
